// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2iqpr","cell":"ColumnAccessor_cell__ny5FA","firstCellAccent":"ColumnAccessor_firstCellAccent__2e1SD"};